import React from 'react'
import styles from './styles.module.css'
import get from 'lodash/get'

export default function BrandBar(props) {
  const imgSrc = get(props, 'brand.menuImage.url')

  return (
    <div className={styles.container}>
      {imgSrc ? <img src={props.brand.menuImage.url} /> : null}
    </div>
  )
}
